module.exports = __webpack_public_path__ + "static/rollerblade-tile-c0645646abc83626e5cff21a12aea95a.jpg";